import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Task } from 'src/app/views/pages/calendar/models';

@Injectable({
  providedIn: 'root',
})
export class TaskStateService {
  private isLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private selectedTaskSubject: Subject<Task> = new Subject<Task>();

  public isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();
  public selectedTask$: Observable<Task> = this.selectedTaskSubject.asObservable();

  setLoadingState(isLoading: boolean): void {
    this.isLoadingSubject.next(isLoading);
  }

  setSelectedTask(task: Task): void {
    this.selectedTaskSubject.next(task);
  }

  resetSelectedTask(): void {
    this.selectedTaskSubject.next(null);
  }
}
